import { render, staticRenderFns } from "./QSwitchInput.vue?vue&type=template&id=06f5506c&"
import script from "./QSwitchInput.vue?vue&type=script&lang=js&"
export * from "./QSwitchInput.vue?vue&type=script&lang=js&"
import style0 from "./QSwitchInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VHover,VSwitch,VTextField})
